import {
    Widget,
    IRequestOptions,
    IRequestConfig,
    getConfigs,
    axios,
    basePath
} from './index.defs';

export class WidgetService {
    static widget(options: IRequestOptions = {}): Promise<Widget> {
        return new Promise((resolve, reject) => {
            const url = basePath + '/widget';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, {withCredentials: true});
            configs.data = null;
            axios(configs, resolve, reject);
        });
    }
}
